import React from 'react';
import {Box, Typography} from '@mui/joy';
import {useTranslation} from "react-i18next";
import Compass from "../../Svg/Compass";
import {IOT_STATUS_CONFIG} from "../../../config/iotConnectionStatusConfig";

interface Props {
    azimuth?: number;
}

const GridLegend = ({azimuth = 0}: Props) => {
    const {t} = useTranslation();

    return (
        <Box
            width={220}
            borderLeft="1px solid #ccc"
            p={"13px"}
        >
            <Box sx={{width: "100%", display: "flex", justifyContent: "center", pt: "16px", pb: "24px"}}>
                <Compass style={{rotate: `${azimuth}deg`}}/>
            </Box>
            <Typography level="titleMedium" mb={2}>{t("Legend")}</Typography>
            {IOT_STATUS_CONFIG.map(item => (
                <Box key={item.status} display="flex" alignItems="center" mb={1}>
                    <Box
                        width={16}
                        height={16}
                        bgcolor={item.color}
                        borderRadius="3px"
                        mr={1}
                    />
                    <Typography>{t(item.label)}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default GridLegend;
